<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
               <!-- <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            Students without some form of financial aid should be able to attend
                            university. It is for such individuals that the Office of Scholarships and Student Aid is intended.
                        </p>
                    </div>
                </div>-->

                <div class="uk-padding  uk-margin-remove-top">
                    <h1 class=" uk-text-center specHeading"><span>Financial Aid</span></h1>
                    <div class="uk-container uk-container-small">




                        <h3 class="uk-heading-bullet specHeading">Academic Scholarships</h3>
                        <div class="uk-child-width-1-2@m" uk-grid>
                            <div class="uk-padding uk-text-center uk-align-center uk-visible@m">
                                <img src="../assets/financialaid1.jpg" alt="">
                            </div>
                            <div class="uk-padding">
                                <p class="">
                                    Several academic departments are the recipients of annual academic
                                    assistance in the form of scholarships provided by alumni and other supporters of the university.
                                    <br><br>
                                    The scholarships are awarded annually to students in those
                                    departments who meet eligibility requirements.


                                </p>
                                <p class="uk-text-muted -small">
                                    To find out what scholarships are available, check with the
                                    Department of Scholarships, Grants & Loans, and the Department of Enrolment Services & Corporate Alliance.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-padding uk-background-muted uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Special Scholarships</h3>
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div class="">
                                <p class="">
                                    Supporting organizations such as banks, corporations and other entities, make scholarships available
                                    to students who meet certain requirements.  Various other scholarships for academic performance, freshman scholarships,
                                    graduation from Seventh-day Adventist high schools, alumni awards and for students enrolled in specific
                                    disciplines, are also available. Check with the department chair, the dean of the college to which they
                                    are applying, or with the department of Alumni Relations and Planned Giving for current information and details.
                                </p>
                            </div>
                            <div class="uk-padding-remove-vertical uk-text-center uk-align-center uk-visible@m uk-margin-remove-top" >
                                <img src="../assets/specschol.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Student Loans</h3>
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div class="uk-padding">
                                <p class="">
                                    Loans are available through the Students' Loan Bureau. To be qualified, students must have been fully
                                    accepted and matriculated for a full course of study at the university. Students' Loan applications
                                    are made directly to the Bureau. Application dates and eligibility requirements are advertised in the local newspapers.
                                </p>

                            </div>
                            <div class="uk-padding uk-text-center uk-align-center uk-visible@m">
                                <img src="../assets/slb.jpg" alt="">
                            </div>
                        </div>
                        <p class="uk-margin-remove-top uk-text-small uk-text-muted">
                            Prospective students are strongly advised to consult with the Students' Loan Bureau for details and dates of application.
                            Students who are granted loans (which must be repaid after graduation), may also qualify for Grant In Aid toward housing,
                            transportation and living expenses. This amount is generally not repayable to the Bureau, but must be used for the purposes
                            specified. Students may also contact the department of Enrolment Services for details and application forms
                            (There is a fee for the application forms).
                        </p>
                        <!--<div class="uk-text-center uk-align-center">
                            <video class="uk-align-center" style="border-radius: 5px" src="/SLBAPPLICANTVIDEO.mp4" controls playsinline  uk-video></video>
                        </div>-->
                    </div>
                </div>

                <div class="uk-padding uk-background-muted uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Recruitment Incentives</h3>
                        <div class="uk-child-width-1-2@m" uk-grid>
                            <div class="uk-padding uk-text-center uk-align-center uk-visible@m">
                                <img src="../assets/financialaid3.jpg" alt="">
                            </div>
                            <div class="uk-padding">
                                <p class="">
                                    The enrolment Services Department makes incentive awards to students who recruit a certain number of full
                                    fee-paying students to attend the university. The amount of the award and the eligibility requirements are
                                    modified each year. Students should check with the department to find out availability and the requirements
                                    for the year in which they have been accepted.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">University Loans</h3>
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div class="uk-padding">
                                <p class="">
                                    A limited number of loans are available to final year students who are having difficulty with finances.
                                    Students are required to sign a loan agreement, and these loans must be repaid within two years after graduation.
                                </p>
                            </div>
                            <div class="uk-padding uk-text-center uk-visible@m uk-align-center">
                                <img src="../assets/ncu-logo.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="uk-padding uk-background-muted">
                    <div class="uk-container uk-container-small uk-padding-small">
                        <div uk-grid>

                            <div class="uk-width-1-1">
                                <h3 class="uk-heading-bullet uk-text-muted">Incomplete Applications</h3>
                                <p class="uk-text-small uk-text-muted">
                                    Applicants are reminded that if they were given provisional acceptance and have not yet fulfilled the requirements for acceptance into their programmes,
                                    which include meeting the standard for matriculation, be interviewed by their departments and submission of all outstanding documents, they will not be
                                    given a formal acceptance letter at the New Students’ Meeting.

                                    <br><br>
                                    If you have any questions concerning your admissions process, please feel free to call us at the office at:
                                    <br><br>
                                    Phone: 1-876-963-7250-7
                                    <br><br>
                                    For more information contact admissions@ncu.edu.jm
                                </p>
                            </div>
                        </div>
                    </div>
                </div>-->
            </div>

        </div>
    </transition>
</template>

<script>
    export default {
        name: "FinancialAid"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h1{
            font-size: 1.5em !important;
        }
        h3{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
